import type { RigListItem } from '@chukua/common';
import { useMemo, useState } from 'react';
import { trailerSubject, truckSubject, type CoupleSubject } from '../../../policies/couple-options';
import type { UnitRowAction } from '../components/UnitRowActions';

/** Which row's couple drawer is open on the Units list, and the couple subject it implies. */
export function useUnitRowActions() {
  const [open, setOpen] = useState<{ action: UnitRowAction; rig: RigListItem } | null>(null);

  const subject = useMemo((): CoupleSubject | null => {
    if (!open) return null;
    return open.action === 'couple-truck' ? truckSubject(open.rig) : trailerSubject(open.rig);
  }, [open]);

  return { open, subject, start: (action: UnitRowAction, rig: RigListItem) => setOpen({ action, rig }), close: () => setOpen(null) };
}
